import { useState } from 'react';
import { toast } from 'react-toastify';
import { FaRegStar, FaStar } from "react-icons/fa";
import ButtonPrimary from "./style-components/ButtonPrimary";
import Rating from 'react-rating';

function ProductContent({ product, handleAddToCart }) {
  // Automatically select the first variant
  const [selectedVariant, setSelectedVariant] = useState(product.variants[0]);
  const currentLang = localStorage.getItem('lang') || 'lv';

  const handleVariantChange = (event) => {
      const variantId = event.target.value;
      const variant = product.variants.find(v => v._id === variantId);
      setSelectedVariant(variant);
    };

  const cartHandler = () => {
    if (!selectedVariant) {
      toast.error(currentLang === 'en' ? 'Please select a size!' : 'Lūdzu izvēlies izmēru!');
    } else {
      const product_object = { ...product, variant: selectedVariant };
      handleAddToCart(product_object);
    }
  }

  // Helper function to format price
  const formatPrice = (price) => (price / 100).toFixed(2);


  return (
    <div className="product-content">
      <h1>
        {currentLang === 'en' ? (product.title_english || product.title) : product.title}
      </h1>
      {product.rating && 
        <Rating 
          emptySymbol={<FaRegStar size={15} color="#ffc000" />}
          fullSymbol={<FaStar size={15} color="#ffc000" />}
          initialRating={product.rating}
          readonly
        />
      }
      <p
        className="product-description padding-20-top"
        dangerouslySetInnerHTML={
          { __html: currentLang === 'en' ? (product.description_english || product.description) : product.description }}
      ></p>
        <div className="product-info padding-20-top">
        {(product.category === "Sēņu micēlija bloks" || product.category === "Sēņu audzēšanas komplekts") && 
          <>
            <p><span className="bold">{currentLang === 'en' ? "Grow length:" : "Augšanas ilgums:"} </span>{product.grow_time_min} - {product.grow_time_max} {currentLang === 'en' ? 'weeks' : 'nedēļas'} </p>            <p><span className="bold">{currentLang === 'en' ? "Grow temperature:" : "Augšanas temperatūra:"} </span>{product.grow_temp_min} - {product.grow_temp_max} °C</p>
            <p><span className="bold">{currentLang === 'en' ? "Shelf life:" : "Uzglabāšanas termiņš:"} </span>{product.valid_for} {currentLang === 'en' ? 'months' : 'mēneši'}</p>
          </>
        }
        {(selectedVariant && product.variant_type) && <p><span className="bold">{currentLang === 'en' ? (product.variant_type_english || product.variant_type) : product.variant_type}: </span>{currentLang === 'en' ? (selectedVariant.variant_name_english || selectedVariant.variant_name) : selectedVariant.variant_name}</p>}
      </div>

      {product.variants.length > 1 &&  
      <div className="flex column gap-10">
        <div className="variant-select flex padding-10-top">
          <select
            defaultValue={selectedVariant ? selectedVariant._id : "def"}
            className="basic-input"
            name="variant-select"
            id="variant-select"
            onChange={handleVariantChange}
          >
            <option value="def" disabled>
              {product._id === '67594415b22277743b4df42e' ? "Izvēlies summu" : "Izvēlies izmēru"}
            </option>
            {product.variants.map(variant => (
              <option 
                key={variant._id} 
                value={variant._id} 
                disabled={variant.countInStock === 0}
                selected={selectedVariant?._id === variant._id}
              >
                {variant.variant_name} {variant.countInStock === 0 ? "(Nav pieejams)" : ""}
              </option>
            ))}
          </select>
          
        </div>
        {product.variants.every(variant => variant.countInStock === 0) && (
            <div className="out-of-stock-message">{currentLang === 'en' ? 'Out of stock!' : 'Nav noliktavā!'}</div>
          )}  
      </div>
      }

      {selectedVariant && 
      <div>
        {/* For 2-5 items left */}
        {(selectedVariant.countInStock < 6 && selectedVariant.countInStock > 1) && 
            <p className="low-stock padding-20-top">
                {currentLang === 'en' ? `Only ${selectedVariant.countInStock} items left!` : `Pēdējās ${selectedVariant.countInStock} preces!`}
            </p>
        }

        {/* For 1 item left */}
        {selectedVariant.countInStock === 1 && 
            <p className="low-stock padding-20-top">
                {currentLang === 'en' ? 'Last item in stock!' : 'Pēdējā prece noliktavā!'}
            </p>
        }
        <p className={`product-price padding-20-top padding-10-bottom`}>
          <span className={`${(selectedVariant.discount_price && selectedVariant.discount_price > 0) ? 'discounted' : null}`}>€{formatPrice(selectedVariant.price)}</span>
          {(selectedVariant.discount_price && selectedVariant.discount_price > 0) ? <span>{selectedVariant.discount_price && `€${formatPrice(selectedVariant.discount_price)}`}</span> : null}
        </p>
        {selectedVariant.countInStock < 1 ? <p className="out-of-stock padding-20-top">{currentLang === 'en' ? 'Out of stock' : 'Nav noliktavā'}</p> : <ButtonPrimary 
          role="button"
          tabIndex="0"
          text={currentLang === 'en' ? "Add to cart" : "Pievienot grozam"}
          onClick={cartHandler} 
          disabled={selectedVariant.countInStock < 1} 
          className={`add-to-cart-button ${selectedVariant.countInStock < 1 ? 'out-of-stock' : ''}`}
        />}
        
      </div>}
    </div>
  );
}

export default ProductContent;